/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SlotsPopover/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DateAndMetrics from './DateAndMetrics/index'
import DoctorsAndAssistants from './DoctorsAndAssistants/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SlotsPopover({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/SlotsPopover"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="SlotsPopover.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1T65nm': dtColorsWhite,'--pl-2-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-4-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-6-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-8-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-9-1T65nm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-10-1T65nm': dtColorsNeutral200}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<DateAndMetrics
  viewPath={`${viewPath}/DateAndMetrics`}
/>
<DoctorsAndAssistants
  viewPath={`${viewPath}/DoctorsAndAssistants`}
/>
</div>
{children}
</React.Fragment>)
}